import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="brut-card px-8 py-6 font-heading text-xl">LOADING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
